import { ProjectId } from 'Constants/Projects/types'

export const PROJECT_BENEFITS = {
  [ProjectId.WorkAxle]: [
    '30,000 users online',
    'Raised $2,800,000 CAD',
    'Went to Enterprise in less than 3 years',
  ],
  [ProjectId.Morpheus]: [
    'Doubled Trading Volume',
    'Reached $114M Market Cap',
    '$3.3M worth tokens staked within 3 days',
  ],
  [ProjectId.Sentr3]: [
    'Got popular within crypto communities with first 3 months of existence',
    'Raised $800,000 CAD',
  ],
  [ProjectId.NetworkOS]: [
    'Process relationship of more than a billion user records',
    'Attracted giants: United Health Group, PwC, Gilead and IFC',
  ],
}
